import {
    doResultListUpdate
} from './_doResultListUpdate';
import {
    clearFilters
} from './_mobileFilterCrumbs';

var facetRemoveLink = function(removeId) {
    $("#" + String(removeId)).prop("checked", "").data("dontscroll", "true").trigger("change").removeData("dontscroll");
};

var facetRemoveAllLink = function(removeId) {
    if ($('.mobilePage').length > 0) clearFilters();
    $(".facet input").each(function() {
        $(this).data("dontfirecheck", "true").prop("checked", "").removeData("dontfirecheck");
    });
    $("#facetFilterList li").remove();
    $("#filteredBy, .filtered-by").hide();
    $(".clearAll").hide();
    $("#beginIndex").val("0");
    doResultListUpdate();
};

export {facetRemoveAllLink,facetRemoveLink}
